import React from "react";
import { useTheme } from "../../providers/theme-provider";
import spacings from "../../theme/spacings";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import { fontSizes } from "../../theme/font-sizes";
import { assetIcons } from "../../constants/assets";
import { color } from "framer-motion";

const Services = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;

  const services = [
    {
      icon: assetIcons.light,
      title: t("services.title1"),
      description: t("services.description1"),
    },
    {
      icon: assetIcons.furniture,
      title: t("services.title2"),
      description: t("services.description2"),
    },
    {
      icon: assetIcons.tree,
      title: t("services.title3"),
      description: t("services.description3"),
    },
  ];

  return (
    <div
      style={{
        backgroundColor: colors.heroBg,
        paddingLeft: paddingLeftRight,
        paddingRight: paddingLeftRight,
        paddingTop: paddingTopBottom,
        paddingBottom: paddingTopBottom,
      }}
      className="max-w-[1400px] mx-auto "
      id="services"
    >
      <div className="flex flex-col md:gap-8 gap-6">
        <div className="flex flex-row gap-6 items-center">
          <div
            className="h-[1px] md:w-[100px] w-[60px] "
            style={{
              backgroundColor: colors.mainHeading,
            }}
          ></div>
          <h3
            style={{
              color: colors.mainHeading,
              fontSize: fontSizes.heading2,
            }}
            className="font-semibold"
          >
            {t("serviceHeading")}
          </h3>
        </div>

        <div className="lg:grid lg:grid-cols-3 lg:gap-3 sm:grid sm:grid-cols-2 sm:gap-6 grid grid-cols-1 gap-4 place-content-center ">
          {services.map((service, index) => (
            <div className="flex gap-6 ">
              <div className="mt-2">
                <img src={service.icon} alt="" className="sm:w-20 w-16" />
              </div>
              <div className="flex flex-col md:gap-4 gap-2">
                <h3
                  className="font-semibold"
                  style={{
                    color: color.mainHeading,
                    fontSize: fontSizes.heading3,
                  }}
                >
                  {service.title}
                </h3>
                <p
                  className=""
                  style={{
                    fontSize: fontSizes.body,
                    color: colors.mainText,
                  }}
                >
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
